export const isProd = () => window.location.hostname === 'parkingpay.ch';
